import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EmailCapture = () => {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  let submitLabel = done ? "Joined ✓" : "Join free";
  if (loading) submitLabel = "Joining…";

  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, {
        email: trimmed,
        source: "free-tools",
        website, // honeypot
      });
      setDone(true);
      setEmail("");
      toast.success("You're on the list. Free tools coming your way.");
    } catch (err) {
      const msg =
        err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast.error(typeof msg === "string" ? msg : "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="free-tools"
      data-testid="section-email-capture"
      className="bg-white border-y border-[#E7E7E2]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 md:py-32 text-center">
        <div className="overline">— Free tools</div>
        <h2 className="mt-5 font-sora text-[36px] sm:text-[44px] lg:text-[52px] font-bold text-[#111111] tracking-tight leading-[1.05]">
          Get free digital tools
          <br />
          from Vaymilo.
        </h2>
        <p className="mt-6 font-manrope text-[16px] md:text-[17px] text-[#111111]/65 leading-relaxed max-w-xl mx-auto">
          Join the list for free prompts, templates, product updates, and
          launch discounts.
        </p>

        <form
          onSubmit={onSubmit}
          data-testid="email-capture-form"
          className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          {/* Honeypot — hidden from humans, visible to bots */}
          <div className="vaymilo-honeypot" aria-hidden="true">
            <label htmlFor="ec-website">Website (leave empty)</label>
            <input
              id="ec-website"
              type="text"
              name="website"
              tabIndex={-1}
              autoComplete="off"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              data-testid="honeypot-subscribe"
            />
          </div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@domain.com"
            data-testid="input-email-capture"
            disabled={loading}
            aria-label="Email address"
            className="flex-1 bg-white border border-[#E7E7E2] rounded-lg px-4 py-3.5 text-[15px] text-[#111111] placeholder:text-[#111111]/40 font-manrope focus:outline-none focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20 transition-all disabled:opacity-60"
          />
          <button
            type="submit"
            data-testid="btn-email-submit"
            disabled={loading}
            className="inline-flex items-center justify-center bg-[#111111] hover:bg-[#2563EB] disabled:opacity-60 text-white font-manrope font-medium text-[15px] px-6 py-3.5 rounded-lg transition-colors"
          >
            {submitLabel}
          </button>
        </form>

        <p
          data-testid="email-privacy-note"
          className="mt-4 font-manrope text-[13px] text-[#111111]/55"
        >
          No spam. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
};

export default EmailCapture;
